import { useEffect, useRef, useState } from "react";
import useKeyPress from "@/shared/hooks/useKeyPress";
import useOnClickOutside from "@/shared/hooks/useOnClickOutside";

const useButtonGroupHook = () => {
  const ref = useRef();
  const [expended, setExpend] = useState(false);
  const esc = useKeyPress("Escape");

  const toggle = () => setExpend(!expended);
  const close = () => setExpend(false);

  useOnClickOutside(ref, close);
  useEffect(close, [esc]);

  return { toggle, expended, ref, close };
};

export default useButtonGroupHook;
